import ReactiveComponent, { filter, watch } from '@utils/reactive-component';
import OrderHistoryLine from './order-history-line';
import OrderSelectBox from './order-select-box';
import parseRenderingContext from '@utils/parse-rendering-context';
import orderHistoryService from '@api/routes/orders/orderlisting';
import { context as defaultContext } from './order-history-defaults';

export default class OrderHistory extends ReactiveComponent {
    constructor($originEl, context) {
        super();

        context = { ...defaultContext, ...context };

        this.$el = $originEl;

        this.$lines = this.$el.find('[data-region="lines"]');
        this.$loader = this.$el.find('[data-region="loader"]');

        this.$dateRangePlaceholder = this.$el.find('[data-placeholder="dateRange"]');

        this.dateRangeSelector = null;

        this.context = context;

        this.reactive({
            dateRangeValue: Number(this.context.DateRangeDefault) || this.context.DateRangeDefault,
            loading: true,
            orderLines: []
        });

        this.init();
    }

    [filter]() {
        return {
            dateRangeValue(value) {
                return Number(value) || value;
            },
            orderLines(lines) {
                return lines?.map((line) => ({
                    date: line.Date,
                    items: line.ItemsInOrder,
                    link: line.DetailsLink,
                    orderNumber: line.OrderNumber,
                    total: line.OrderTotal,
                    status: line.Status
                })) || [];
            }
        }
    }

    [watch]() {
        return {
            dateRangeValue() {
                this.getOrderHistory();
            },
            loading(loading) {
                if(loading) {
                    this.$loader.show();
                    this.$lines.hide();
                } else {
                    this.$loader.hide();
                    this.$lines.show();
                }
            },
            orderLines() {
                this.renderLines();
            }
        }
    }

    init() {
        this.setupDateRange();
        this.setupListeners();
    }

    async getOrderHistory() {
        this.loading = true;

        this.removeErrorMessage();

        const response = await orderHistoryService.post({
            HistoryInMonths: this.dateRangeValue
        });

        if(response.success) {
            this.orderLines = response.data.Orders || [];
        } else {
            let errorMessage = response.error;
            this.$el.append(`<div class="order-history__err-msg"></div>`);
            this.$el.find('.order-history__err-msg').append(`<div class="font-weight-bold">${errorMessage}</div>`);
        }

        this.loading = false;
    }

    onDateRangeChange(value) {
        this.dateRangeValue = value;
    }

    renderLines() {

       this.removeErrorMessage();

        if(this.orderLines.length !== 0) {
            const fragment = document.createDocumentFragment();

            this.orderLines.forEach((line) => {
                const component = new OrderHistoryLine(null, line, this.context);

                fragment.appendChild(component.render()?.get(0));
            });

            this.$lines.html(fragment);
        } else {
            this.$el.append(`<div class="order-history__err-msg"></div>`);
            this.$el.find('.order-history__err-msg').append(`<div class="font-weight-bold">No Invoices to View</div>`);
        }
    }

    removeErrorMessage() {
        let errMessageContainer = this.$el.find('.order-history__err-msg');

        if (errMessageContainer) {
            $(errMessageContainer).remove();
        }
    }

    setupDateRange() {
        const options = this.context.DateRangeOptions?.map((option) => ({
            text: option.Text,
            value: option.Value
        }));

        this.dateRangeSelector = new OrderSelectBox(this.$dateRangePlaceholder, {
            name: 'DateRange',
            options,
            value: this.context.DateRangeDefault
        });

        this.dateRangeSelector.render();
    }

    setupListeners() {
        this.dateRangeSelector.watchValue((value) => this.onDateRangeChange(value));
    }
}

$(async () => {
    const el = document.querySelector('.js-order-history');

    if(el) {
        const $el = $(el);
        const renderingContext = parseRenderingContext(el);

        const history = new OrderHistory($el, renderingContext);
        history.getOrderHistory();
    }
});
